import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import {Formik,Form} from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";


const CreateModeOfTravel = (props) => {
  const [ModeOfTravelType,setModeOfTravelType] = useState('');
  const [ModeOfTravel,setModeOfTravel] = useState('');
  const [response,fetchData] = UseFetchData();
  const [responseCombo,fetchComboData] = UseFetchData(); 
  const [responseGetData,fetchGetData] = UseFetchData();
  const [TravelTypecmb,setTravelTypecmb] = useState([]);

  const validationSchema = Yup.object({
    ModeOfTravelType : Yup.string().required('Required!'),
    ModeOfTravel : Yup.string().required('Required!'),
  });

  const TravelTypeOption = [
    { key:"Local",value:"Local" }, 
    { key:"OutStation",value:"OutStation" },
  
  ];

  const onSubmit = values => {
    debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("Type",'Mode Of Travel');
    bodyFormData.append("PKID",props.PKID);
    bodyFormData.append("Value1",values.ModeOfTravelType);
    bodyFormData.append("Value2",values.ModeOfTravel);
    fetchData("Primary/Save",bodyFormData);
  }

  const getByIDData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("Type",'Mode Of Travel');
    bodyFormData.append("PKID",props.PKID);
    fetchGetData("Primary/GetByID",bodyFormData);
  }

  const Traveldataopt = () => {
    debugger;
    let TravelCombo = TravelTypeOption.map((data) =>
    <option
    
    key = {data.key}
    value = {data.value}
    >
      {data.key}
    </option>
    );
    setTravelTypecmb(TravelCombo);
  };

  useEffect(() => {
    if(response.Response === true) {
      props.setOpen(false);
      props.PopulateData();
      alert('Saved Successfully.')
    }
    else if(response.Response === false){
       alert('Save Failed.')
    }
  },[response])

  useEffect(() => {
    debugger;
    Traveldataopt(responseCombo);
  },[responseCombo])

  useEffect(() => {
    if(responseGetData.length > 0) {
      setModeOfTravelType(responseGetData[0].ModeOfTravelType);
      setModeOfTravel(responseGetData[0].ModeOfTravel);
    }
  },[responseGetData])

  useEffect(() => {
  if(props.PKID != ''){
    getByIDData();
  }
  },[])

  return(<div>
    <Formik initialValues={{ModeOfTravelType:ModeOfTravelType,ModeOfTravel:ModeOfTravel}}
      validationSchema = {validationSchema} onSubmit = {onSubmit} enableReinitialize>
        {formik => {
          return <Form>
            <Grid spacing={2} container>
              <Grid item xs={12}>
                <BiztranControlsFormik
                  control='select'
                  label = 'Travel Type'
                  name = 'ModeOfTravelType'
                  options={TravelTypecmb}
                  onChange = {(e) => setModeOfTravelType(e.target.value)}
                />
              </Grid>
              <Grid item xs= {12}>
                <BiztranControlsFormik
                control = 'input'
                type = 'text'
                label = 'Travel Name'
                name = 'ModeOfTravel'
                onChange = {(e) => setModeOfTravel(e.target.value)}
                />

              </Grid>
              <Grid item xs= {12}>
                <div style = {{width:'100%'}}>
                  <div style = {{display:'flex',justifyContent:'center',alignContent:"center"}}>
                    <BiztranControls.Button 
                      text = "SAVE"
                      type = "submit"
                      startIcon = {<SaveIcon/>}
                    />
                    <BiztranControls.Button
                      text = "CLOSE"
                      startIcon = {<CloseIcon/>}
                      onClick= {() => {props.setOpen(false);}}
                    />
                  </div>
                </div>
              

              </Grid>
            </Grid>
          </Form>
        }}
      </Formik>
  </div>)

}

export default CreateModeOfTravel ;